import type BadRequestErrorResponse from "@app/config/api/responses/BadRequestErrorResponse";
import { usePostParseDataset } from "@app/queries/datasets";
import type { CSVParseOutput, GenericErrorWithSuggestionResponse } from "@globals";
import DatasetParseErrorAlert from "@lib/dataset/parseError/DatasetParseErrorAlert";
import parseDatasetError from "@lib/dataset/parseError/parseDatasetError";
import { Box, LoadingOverlay, Transition } from "@mantine/core";
import type { FileWithPath } from "@mantine/dropzone";
import { useEffect, useState } from "react";

export default function ParseDatasetView({
  file,
  onComplete
}: {
  file: FileWithPath;
  onComplete: (result: CSVParseOutput) => void;
}) {
  const [parseError, setParseError] = useState<GenericErrorWithSuggestionResponse | null>(null);
  const postParseDataset = usePostParseDataset();

  useEffect(() => {
    const executeParseDataset = async () => {
      const formData = new FormData();
      formData.append("file", file);

      await postParseDataset
        .mutateAsync({ body: formData })
        .then(result => onComplete(result))
        .catch((error: BadRequestErrorResponse) => {
          setParseError(parseDatasetError(error));
        });
    };

    void executeParseDataset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, onComplete]);

  return (
    <Box mih={200} p="lg">
      <LoadingOverlay visible={postParseDataset.isPending} />
      <Transition mounted={parseError !== null}>
        {styles => <Box style={styles}>{parseError && <DatasetParseErrorAlert error={parseError} />}</Box>}
      </Transition>
    </Box>
  );
}
